export const randomString = () => Math.random().toString(36).substring(2, 13);



// WEBPACK FOOTER //
// ./shared/lib/random/index.js